<div class="container">
  <div class="mobile-nav-dash">
    <button class="upcoming-order-btn active-nav-dash" (click)="restbtn()">Events </button>
    <button class="events-btn" (click)="eventbtn()">Events</button>
  </div>
    <div class="Section_PH teamdashsec">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" id="event-sect">
              <div class="container-fluid">
                <h1 class="mb31">Calendar</h1>
                <mat-card class="demo-inline-calendar-card">
                    <mat-calendar [(selected)]="selected" [minDate]="todayDate"
                        (selectedChange)="onClickChangeDate($event)"></mat-calendar>
                </mat-card>
                <!-- <p>Selected date: {{ selected }}</p> -->

                <h1 class="" style="padding: 20px 0px 20px 0px; margin-bottom: 0px;">Upcoming Orders</h1>
                <div class="img36 d-flex justify-content-center" *ngIf="EventList?.length == 0 || EventList?.length == undefined">
                  <img style="margin-top: 10%" src="../../../../assets/icons/36.png" />
                </div>
                <div class="UpcomingOrdsTeam" id="UpcomingOrdsTeam" *ngIf="EventList?.length > 0">
                    <mat-card class="eventCard" *ngFor="let i of EventList"
                        style="margin-bottom: 20px; border-radius: 15px">
                        <!-- <mat-checkbox class="example-margin">{{i?.eventTitle}}</mat-checkbox> -->
                        <div class="example-margin">{{i?.eventData[0]?.eventTitle}}</div>
                        <div style="margin-bottom: 10px">
                            <img class="eventicons" src="../../../../assets/image/calendar-event (1).svg" alt="invalid" />&nbsp;
                            <span class="span-item">{{i?.eventData[0]?.eventDate | date:'MMM dd, YYYY': 'UTC'}}</span>
                            <!-- <span class="span-item">{{i?.eventTitle}} {{formattedEventDate}}</span> -->


                        </div>
                        <div>
                            <img class="timeeicon" src="../../../../assets/image/soup.svg" alt="invalid" />&nbsp;
                            <span class="span-item">{{i?.restaurantData[0]?.restaurantName}}</span>
                        </div>
                        <!-- P-button -->
                        <div>
                            <button type="submit" [ngClass]="{'D-button':i?.eventData[0]?.deliveryMethod!='pickup','P-button':i?.eventData[0]?.deliveryMethod=='pickup'}" style="cursor: text;">{{i?.eventData[0]?.deliveryMethod | titlecase}}</button>
                        </div>
                    </mat-card>
                </div>



              </div>

            </div>

            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8" id="upcoming-order-sect">
                <div class="row">
                    <div>
                        <h1 class="teamdashrest">Events </h1>
                    </div>
                    <div style="position: relative">
                        <span><img class="search-icon" src="../../../../assets/image/search.svg" alt="invalid" /></span>
                        <input type="text" (keyup)="search()" placeholder="Search restaurant name" [(ngModel)]="searchData" class="searchField" />
                        <span *ngIf="searchData" class="searchfieldmob" (click)="clearFilter()">
                          <img class="search-delete" src="../../../../../assets/SVG/icon-close-512 (1).webp" (click)="clearFilter()" alt=""></span>
                    </div>
                    <div>
                        <div class="row">
                            <div style="margin-top: 10px;" class="col-lg-6 col-md-12 col-sm-12 col-xs-12 teamdashgrid"
                                *ngFor="let i of restaurantList">
                                <div class="card-one">
                                    <div class="" style="display: flex;
                                    gap: 10px;">
                                            <div class="">
                                                <img class="img-back" [src]="i?.restaurantData?.logo" />
                                            </div>
                                            <div class="card-content">
                                                <h1 class="first-h" style="font-size: 24px !important;overflow-wrap: anywhere;height: 50px;">{{checkResolutionRestaurantName(i?.restaurantData.restaurantName)}}</h1>
                                                <h3 class="second-h">{{i?.eventTitle | titlecase}} {{i?.eventDate | date:'MMM dd, YYYY': 'UTC'}}</h3>
                                                <div style="display: flex">
                                                    <img class="mapwidthh" src="../../../../assets/icon/map-pin.png"
                                                        style="width: 24px; height: 24px" />&nbsp;&nbsp;
                                                    <h5 class="third-h">
                                                        <!-- {{i?.restaurantData.address}} -->
                                                        {{checkResolution(i?.restaurantData.address)}}
                                                    </h5>
                                                </div>
                                            </div>

                                    </div>
                                    <div class="row two-btn">
                                        <div class="col-lg-4 col-md-4 col-6">
                                            <!-- <div>
                          <button type="button" class="Del-btn"
                            [ngClass]="i.deliveryMethod === 'Delivary' ? 'blue-bg' : 'pink-bg'">
                            {{ i?.deliveryMethod }}
                          </button>
                        </div> -->


                                            <div>
                                                <button type="button" class="Del-btn" [ngClass]="{'Delivery-button': i?.deliveryMethod=='pickup'}"  style="cursor: text ;">{{i?.deliveryMethod |
                                                    titlecase}}</button>
                                            </div>

                                        </div>
                                        <div class="col-lg-4 col-md-4 col-6">
                                            <div>
                                                <button type="button" class="vm-btn" (click)="ViewMenu(i)">
                                                    View Menu
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="restaurantList?.length==0 || restaurantList?.length==undefined" class="text-center">
                              <h1 class="no_dataFound" style="font-size: 20px !important;">No Event Found</h1>
                          </div>

                            <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="card-one">
                    <div class="row">
                      <div class="col-md-3 col-4">
                        <div class="img-back">
                          <img
                            class="img-back"
                            src="../../../../assets/image/Group 1261153964.svg"
                          />
                        </div>
                      </div>
                      <div class="col-md-9 col-8">
                        <div class="card-content">
                          <h1 class="first-h">Chick-fil-A</h1>
                          <h3 class="second-h">Plano July 18</h3>
                          <div style="display: flex">
                            <img
                              src="../../../../assets/icon/map-pin.png"
                              style="width: 24px; height: 24px"
                            />&nbsp;&nbsp;
                            <h5 class="third-h">
                              4476 George St, Sydenham, ON K0H 2T0, Canada
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row two-btn">
                      <div class="col-lg-4 col-md-6 col-6">
                        <button type="button" class="Del-btn">Delivery</button>
                      </div>
                      <div class="col-lg-4 col-md-6 col-6">
                        <button type="button" class="vm-btn">View Menu</button>
                      </div>
                    </div>
                  </div>
                </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div></div>